<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M10,14C10,14,2,14,2,14C2,14,2,2,2,2C2,2,6,2,6,2C6,2,6,6,6,6C6,6,7,6,7,6C7,5.17,7.36,4.45,7.91,3.91C7.91,3.91,7.88,3.88,7.88,3.88C7.88,3.88,8.78,2.98,8.78,2.98C8.3,2.45,8,1.77,8,1C8,1,7,0,7,0C7,0,1,0,1,0C0.45,0,0,0.45,0,1C0,1,0,15,0,15C0,15.55,0.45,16,1,16C1,16,11,16,11,16C11.55,16,12,15.55,12,15C12,15,12,8.22,12,8.22C11.47,8.7,10.77,9,10,9C10,9,10,14,10,14C10,14,10,14,10,14ZM15,0C15,0,11,0,11,0C10.45,0,10,0.45,10,1C10,1.55,10.45,2,11,2C11,2,12.59,2,12.59,2C12.59,2,9.29,5.29,9.29,5.29C9.11,5.47,9,5.72,9,6C9,6.55,9.45,7,10,7C10.28,7,10.53,6.89,10.71,6.71C10.71,6.71,14,3.41,14,3.41C14,3.41,14,5,14,5C14,5.55,14.45,6,15,6C15.55,6,16,5.55,16,5C16,5,16,1,16,1C16,0.45,15.55,0,15,0C15,0,15,0,15,0Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'DocumentShare',
} as DefineComponent
</script>
